import { createContext, useContext } from 'react';
import type { DocumentEditingApi } from 'types/documentEditing';

export const DocumentEditingContext = createContext<DocumentEditingApi | null>(null);

export const useDocumentEditing = () => {
  const context = useContext(DocumentEditingContext);
  if (!context) throw new Error('Document editing requires DocumentEditingProvider');
  return context;
};
